<template>
  <div id="app">
    <JobBoard />
  </div>
</template>

<script>
import JobBoard from './components/JobBoard/JobBoard';

export default {
  name: 'App',
  components: {
    JobBoard,
  },
  mounted() {
      this.$store.dispatch('fetchJobs')
      this.$store.dispatch('fetchFilterItems')
  }
};
</script>
